import React, {useContext} from 'react';
import { Link, Redirect } from 'react-router-dom';
import Cookies from 'js-cookie';
import secureLocalStorage from 'react-secure-storage';
import { UserContext } from "../context/users-context";

const UserBar = ({openMenu}) => {
  
  const [redirect, setRedirect] = React.useState(false);
  const [redirectPath, setRedirectPath] = React.useState('');
  const [redirectMessage, setredirectMessage] = React.useState('');
  const UserCunsumer = useContext(UserContext);

  const logout = () => {
    Cookies.remove('jwt');
    secureLocalStorage.clear();
    setRedirectPath('/auth/login');
    setredirectMessage('Вы вышли из системы.');
    setRedirect(true);
  };

  const renderRedirect = () => {
    if (redirect && redirectPath) {
      return (
        <Redirect
          to={{
            pathname: redirectPath,
            notify: {
              type: 'success',
              title: 'Успех ✅',
              message: redirectMessage,
            },
          }}
        />
      );
    }
  };

  const renderActiveClass = (type) => {
    if (window.location.pathname === type) {
      return 'active';
    }
  };

  return (
    <>
      {renderRedirect()}
      <aside
        id='layout-menu'
        className={`layout-menu menu-vertical menu bg-menu-theme menu-mobil ${UserCunsumer.openMenu === false ? 'd-none' : window.innerWidth < 768 && 'animate__animated animate__fadeInLeft animate__faster'}`}
        style={{ width: '18.25rem',zIndex: '1080' }}
      >
        <div className='app-brand demo'>
          <Link to='/user/home' className='sidebar-brand' 
            onClick = {() => {
              if (window.innerWidth <= 768) {
                UserCunsumer.setOpenMenu(false)
              }
            }}>
            <img src={require('../images/logo2.png')} className='me-5' width={'110px'} alt='' />
          </Link>
          <a className='layout-menu-toggle menu-link text-large ms-5 mb-2 icon-menu-mobil-media' 
            onClick = {() => {UserCunsumer.setOpenMenu(false)}}>
            <svg
              width='22'
              height='22'
              viewBox='0 0 22 22'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                d='M11.4854 4.88844C11.0081 4.41121 10.2344 4.41121 9.75715 4.88844L4.51028 10.1353C4.03297 10.6126 4.03297 11.3865 4.51028 11.8638L9.75715 17.1107C10.2344 17.5879 11.0081 17.5879 11.4854 17.1107C11.9626 16.6334 11.9626 15.8597 11.4854 15.3824L7.96672 11.8638C7.48942 11.3865 7.48942 10.6126 7.96672 10.1353L11.4854 6.61667C11.9626 6.13943 11.9626 5.36568 11.4854 4.88844Z'
                fill='currentColor'
                fillOpacity='0.6'
              />
              <path
                d='M15.8683 4.88844L10.6214 10.1353C10.1441 10.6126 10.1441 11.3865 10.6214 11.8638L15.8683 17.1107C16.3455 17.5879 17.1192 17.5879 17.5965 17.1107C18.0737 16.6334 18.0737 15.8597 17.5965 15.3824L14.0778 11.8638C13.6005 11.3865 13.6005 10.6126 14.0778 10.1353L17.5965 6.61667C18.0737 6.13943 18.0737 5.36568 17.5965 4.88844C17.1192 4.41121 16.3455 4.41121 15.8683 4.88844Z'
                fill='currentColor'
                fillOpacity='0.38'
              />
            </svg>
          </a>
        </div>
        <div className='menu-inner-shadow'></div>
        <ul className='menu-inner py-1'>
          <li className='menu-header fw-light mt-2'>
            <span className='menu-header-text'>Личный кабинет</span>
          </li>
          <li className={`menu-item ${renderActiveClass('/user/home')}`} 
            onClick = {() => {
              if (window.innerWidth <= 768) {
                UserCunsumer.setOpenMenu(false)
              }
            }}>
            <Link to='/user/home' className='menu-link'>
              <i className='menu-icon tf-icons mdi mdi-home-account'></i>
              <div data-i18n='Email'>Главная</div>
            </Link>
          </li>
          <li className={`menu-item ${renderActiveClass('/user/withdraw')}`} 
            onClick = {() => {
              if (window.innerWidth <= 768) {
                UserCunsumer.setOpenMenu(false)
              }
            }}>
            <Link to='/user/withdraw' className='menu-link'>
              <i className='menu-icon tf-icons mdi mdi-briefcase-arrow-left-right-outline'></i>
              <div>Вывод баланса</div>
            </Link>
          </li> 
          <li className='menu-header fw-light mt-2'>
            <span className='menu-header-text'>Депозиты</span>
          </li>
          <li className={`menu-item ${renderActiveClass('/user/orders')}`} 
            onClick = {() => {
              if (window.innerWidth <= 768) {
                UserCunsumer.setOpenMenu(false)
              }
            }}>
            <Link to='/user/orders' className='menu-link'>
              <i className='menu-icon tf-icons mdi mdi-format-list-numbered'></i>
              <div data-i18n='Email'>Заявки на депозит</div>
            </Link>
          </li>
          <li className={`menu-item ${renderActiveClass('/user/stats')}`} 
            onClick = {() => {
              if (window.innerWidth <= 768) {
                UserCunsumer.setOpenMenu(false)
              }
            }}>
            <Link to='/user/stats' className='menu-link'>
              <i className='menu-icon tf-icons mdi mdi-tune-vertical'></i>
              <div data-i18n='Email'>Статистика</div>
            </Link>
          </li>
          <li className='menu-header fw-light mt-2'>
            <span className='menu-header-text'>Выплаты</span>
          </li>
          <li className={`menu-item ${renderActiveClass('/user/payments/orders')}`} 
            onClick = {() => {
              if (window.innerWidth <= 768) {
                UserCunsumer.setOpenMenu(false)
              }
            }}
            >
            <Link to='/user/payments/orders' className='menu-link'>
              <i className='menu-icon tf-icons mdi mdi-layers-triple-outline'></i>
              <div data-i18n='Email'>Заявки на выплату</div>
            </Link>
          </li>
          <li className={`menu-item ${renderActiveClass('/user/payments/create')}`} 
            onClick = {() => {
              if (window.innerWidth <= 768) {
                UserCunsumer.setOpenMenu(false)
              }
            }}
            >
            <Link to='/user/payments/create' className='menu-link'>
              <i className='menu-icon tf-icons mdi mdi-view-grid-plus-outline'></i>
              <div data-i18n='Email'>Создать заявку</div>
            </Link>
          </li>
          <li className='menu-header fw-light mt-2'>
            <span className='menu-header-text'>Другое</span>
          </li>
          <li className={`menu-item ${renderActiveClass('/user/settings')}`} 
            onClick = {() => {
              if (window.innerWidth <= 768) {
                UserCunsumer.setOpenMenu(false)
              }
            }}>
            <Link to='/user/settings' className='menu-link'>
              <i className='menu-icon tf-icons mdi mdi-cogs'></i>
              <div data-i18n='Email'>Настройки</div>
            </Link>
          </li>
          <li className={`menu-item`}>
            <Link to='#' className='menu-link' onClick={logout} >
              <i className='menu-icon tf-icons mdi mdi-exit-to-app'></i>
              <div data-i18n='Email'>Выход</div>
            </Link>
          </li>
        </ul>
      </aside>
    </>
  );
};

export default UserBar;